import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { usePrefersReducedMotion } from './motion';
const contacts = [{
  name: 'D. Alvarez',
  last: 'Last job: 14 months ago'
}, {
  name: 'R. Whitfield',
  last: 'Last job: 9 months ago'
}, {
  name: 'S. Kowalski',
  last: 'Last job: 21 months ago'
}, {
  name: 'M. Torres',
  last: 'Last job: 7 months ago'
}];

/* Old contacts sitting grey, then waking one at a time into an emerald
   "texted" state as the campaign reaches them -- literalizes "your old
   contact list re-engaged" instead of just naming it. Staggered
   whileInView reveal, matches the rest of components/visuals; skips
   straight to the end state under reduced motion. */
export function ReengageVisual() {
  const reducedMotion = usePrefersReducedMotion();
  return <div className="w-full overflow-hidden rounded-2xl border border-[#1c1c1c] bg-[#0a0a0a] p-6" data-id="element-815" data-mp="2qepygg4wcsmd">
      <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-neutral-500" data-id="element-816" data-mp="2li977d2ehy52">
        Old contact list, this campaign
      </p>

      <ul className="mt-5 space-y-2.5" data-id="element-817" data-mp="nkquzdiedufr">
        {contacts.map((c, i) => <motion.li key={c.name} initial={reducedMotion ? false : {
        opacity: 0.35
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.4,
        delay: 0.4 + i * 0.25
      }} className="flex items-center justify-between gap-3 rounded-lg border border-[#1c1c1c] bg-[#0d0d0d] px-4 py-3" data-id="element-818" data-mp="semn3zbzcn30" data-mpi={i}>
            <div data-id="element-819" data-mp="1ba398rsl0sox">
              <p className="text-sm font-medium text-neutral-200" data-id="element-820" data-mp="wex221hr2nu0">{c.name}</p>
              <p className="text-xs text-neutral-600" data-id="element-821" data-mp="wgzsgmmteiz9">{c.last}</p>
            </div>
            <motion.span initial={reducedMotion ? false : {
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          delay: 0.7 + i * 0.25
        }} className="flex items-center gap-1.5 rounded-full bg-emerald-500/15 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.1em] text-emerald-500" data-id="element-822" data-mp="11cf375pizyrg">
              <MessageCircleIcon className="h-3 w-3" aria-hidden="true" data-id="element-823" data-mp="1iv5fx9pt9z9b" />
              Texted
            </motion.span>
          </motion.li>)}
      </ul>
    </div>;
}